/**
 * KPMG
 * Expat Tax system API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SmartFormLogicAction } from './smartFormLogicAction';


export interface SmartFormLogic { 
    id?: number;
    smartFormTypeId?: number;
    questionId?: number;
    operator?: SmartFormLogic.OperatorEnum;
    value?: string;
    actions?: Array<SmartFormLogicAction>;
    parent?: SmartFormLogic;
    andChildren?: Array<SmartFormLogic>;
    orChildren?: Array<SmartFormLogic>;
    parentId?: number;
    logicType?: SmartFormLogic.LogicTypeEnum;
}
export namespace SmartFormLogic {
    export type OperatorEnum = 'equals' | 'notEquals' | 'contains' | 'greaterThan' | 'lessThan' | 'answered';
    export const OperatorEnum = {
        Equals: 'equals' as OperatorEnum,
        NotEquals: 'notEquals' as OperatorEnum,
        Contains: 'contains' as OperatorEnum,
        GreaterThan: 'greaterThan' as OperatorEnum,
        LessThan: 'lessThan' as OperatorEnum,
        Answered: 'answered' as OperatorEnum
    };
    export type LogicTypeEnum = 'and' | 'or' | 'root';
    export const LogicTypeEnum = {
        And: 'and' as LogicTypeEnum,
        Or: 'or' as LogicTypeEnum,
        Root: 'root' as LogicTypeEnum
    };
}


